import React, { useEffect } from "react";
import styles from "./styles.module.scss";

import { H2 } from "../../../Components/Texts/Textes";
import { Button } from "../../../Components/buttons/Buttons";
import Logo from "../../../Assets/Images/logo/new_logo.svg";

import Data from "../../../data/fake.data";

import { useSelector, useDispatch } from "react-redux";
import coffeti_actions from "../../../redux/Actions/Cofetti.action";

function Result(props) {
  const result = useSelector((state) => state.ResultsReducer);
  const dispatch = useDispatch();
  const { done } = props;
  useEffect(() => {
    console.log(result);
  }, [result]);

  useEffect(() => {
    if (done) {
      setTimeout(() => {
        dispatch(coffeti_actions.start_cofettiInfinity());
      }, 1000);
    }
  }, [done]);

  const handle_finish = () => {
    window.open("http://vibeviews.com", "_blank");
  };

  const data = Data.Result;

  return (
    <div className={`${styles.question} ${styles.result}`}>
      <H2>{data.title}</H2>
      <span className={styles.info}>{data.hint}</span>

      <div className={styles.logo_container}>
        <img src={Logo} alt="Vibe Views" />
      </div>

      <Button onClick={handle_finish} className={styles.result_btn}>
        Signup for more fun surveys!
      </Button>
    </div>
  );
}

export default Result;
